import _ from 'lodash';
import config from 'sharedConfig';

export function sanitizeCategory(category) {
  const featuredBanners = config.featuredBanners;
  if (
    featuredBanners &&
    featuredBanners.categories &&
    featuredBanners.categories[category.tag]
  ) {
    category.featuredBanner = featuredBanners.categories[category.tag];
  } else {
    category.featuredBanner = null;
  }
  return category;
}

export function breadcrumbsFor(categories) {
  return [...categories]
    .reverse()
    .map(({ name, url, url_name }) => ({ name, url: '/' + (url_name || url) }));
}

export function parentCategories(category, categoryList) {
  if (!category) return [];

  const list = _.keyBy(categoryList, 'id');
  const parentCategory = list[category.id];
  if (!parentCategory) return [];

  let parents = [parentCategory];

  const parentTree = parentCategory.parentTree || [];
  parents = parents.concat(parentTree.map(cat => list[cat.id]));

  return parents;
}
